export default "__VITE_ASSET__Bh4qKOMG__"